import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';

export const PROJECTS_QUERY = gql`
  query Projects($first: Int, $after: String, $status: ProjectStatus) {
    projects(first: $first, after: $after, status: $status) {
      edges {
        node {
          id
          name
          address
          status
          startDate
          endDate
          creator {
            fullName
          }
          members {
            id
            fullName
          }
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

interface UseProjectsOptions {
  first?: number;
  status?: string;
}

export function useProjects(options: UseProjectsOptions = {}) {
  const { data, loading, error, fetchMore, refetch } = useQuery(PROJECTS_QUERY, {
    variables: { first: options.first || 20, status: options.status },
  });

  const projects = (data as any)?.projects?.edges?.map((edge: any) => edge.node) || [];
  const pageInfo = (data as any)?.projects?.pageInfo;

  const loadMore = () => {
    if (pageInfo?.hasNextPage) {
      fetchMore({
        variables: { after: pageInfo.endCursor },
      });
    }
  };

  return { projects, loading, error, loadMore, hasMore: pageInfo?.hasNextPage, refetch };
}